var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 8.82715C11.044 8.82715 13.9167 11.6999 13.9167 15.2438V16.3271H1.08337V15.2438C1.08337 11.6999 3.95611 8.82715 7.50004 8.82715ZM7.50004 7.66048C6.59388 7.66048 5.72484 7.30051 5.08409 6.65976C4.44334 6.01901 4.08337 5.14997 4.08337 4.24382C4.08337 3.33766 4.44334 2.46862 5.08409 1.82787C5.72484 1.18712 6.59388 0.827148 7.50004 0.827148C8.4062 0.827148 9.27524 1.18712 9.91599 1.82787C10.5567 2.46862 10.9167 3.33766 10.9167 4.24382C10.9167 5.14997 10.5567 6.01901 9.91599 6.65976C9.27524 7.30051 8.4062 7.66048 7.50004 7.66048Z",
    fill: "#CDCDCD",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3b21b8c8af017c5197f63b276b6bb644.svg";
export { ForwardRef as ReactComponent };